import getBuyNowAvailablePaymentMethods from '@/modules/buy-now/infrastructure/services/getBuyNowPaymentMethods.queries';
import type { IAvailablePaymentMethodsResponse } from '@/modules/perseo-billing/interfaces';

export async function getBuyNowPaymentMethods(): Promise<IAvailablePaymentMethodsResponse> {
  const response = await getBuyNowAvailablePaymentMethods();
  return response.data;
}
